import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import JobFunctionServices from "./JobFunction.services";
import GeneralInfoServices from "../GeneralInfo/GeneralInfo.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getJobFunction = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: true,
    });
    const resp = await JobFunctionServices.getJobFunction(filters);
    dispatch({
      type: actions.GET_JOB_FUNCTION,
      payload: {
        jobFunctions: resp.data.data,
        jobFunctionsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.JOB_FUNCTION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.JOB_FUNCTION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: false,
    });
  }
};

export const getJobFunctionById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: true,
    });
    const resp = await JobFunctionServices.getJobFunctionById(id);
    dispatch({
      type: actions.GET_JOB_FUNCTION,
      payload: {
        jobFunction: resp.data
      },
    });
    dispatch({
      type: actions.JOB_FUNCTION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.JOB_FUNCTION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: false,
    });
  }
};

export const saveJobFunction = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_JOB_FUNCTION,
      payload: true,
    });
    const resp = await JobFunctionServices.saveJobFunction(data);
    const { jobFunctions, jobFunctionsLength } = getState().jobFunction;
    const _jobFunctions = [...jobFunctions, resp.data];
    dispatch({
      type: actions.GET_JOB_FUNCTION,
      payload: {
        jobFunctions: _jobFunctions,
        jobFunctionsLength: jobFunctionsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_JOB_FUNCTION,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_JOB_FUNCTION,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_JOB_FUNCTION,
      payload: false,
    });
  }
};

export const editJobFunction = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: true,
    });
    const resp = await JobFunctionServices.editJobFunction(id, data);
    const { jobFunctions, jobFunctionsLength } = getState().jobFunction;
    const dataT = resp.data
    jobFunctions[index] = dataT;
    dispatch({
      type: actions.GET_JOB_FUNCTION,
      payload: {
        jobFunctions: jobFunctions,
        jobFunctionsLength: jobFunctionsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_JOB_FUNCTION,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
    const _data = {
      data:[
        {
          funcion_descriptor:dataT.list_descriptor[0].posicion,
          tipo_mensaje:"Jefe actualiza descriptor"
        }
      ]
    }
    await GeneralInfoServices.mailSendGeneralInfo(_data);
    toastr.success(messages.correoEnviado, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.mensaje){
              message = ex.response.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL_JOB_FUNCTION,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: false,
    });
  }
};

export const editFundamentalsJobFunction = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_JOB_FUNCTION,
      payload: true,
    });
    const resp = await JobFunctionServices.editJobFunction(id, data);
    const { jobFunctions, jobFunctionsLength } = getState().jobFunction;
    const dataT = resp.data
    jobFunctions[index] = dataT;
    dispatch({
      type: actions.GET_JOB_FUNCTION,
      payload: {
        jobFunctions: jobFunctions,
        jobFunctionsLength: jobFunctionsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL_JOB_FUNCTION,
      payload: "",
    });
    // setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
    const _data = {
      data:[
        {
          funcion_descriptor:dataT.list_descriptor[0].posicion,
          tipo_mensaje:"Jefe actualiza descriptor"
        }
      ]
    }
    await GeneralInfoServices.mailSendGeneralInfo(_data);
    toastr.success(messages.correoEnviado, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.FORM_FAIL_JOB_FUNCTION,
    //   payload: message,
    // });
    toastr.error(message, '', {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_JOB_FUNCTION,
      payload: false,
    });
  }
};

export const deleteJobFunction = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: true,
    });
    await JobFunctionServices.deleteJobFunction(id);
    const { jobFunctions, jobFunctionsLength } = getState().jobFunction;
    jobFunctions.splice(index, 1);
    dispatch({
      type: actions.GET_JOB_FUNCTION,
      payload: {
        jobFunctions: jobFunctions,
        jobFunctionsLength: jobFunctionsLength - 1,
      },
    });
    dispatch({
      type: actions.JOB_FUNCTION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    // dispatch({
    //   type: actions.JOB_FUNCTION_FAIL,
    //   payload: message,
    // });
    toastr.error(message, '', {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_JOB_FUNCTION,
      payload: false,
    });
  }
};
